import React from "react";
import { Segment, Button, Grid, Icon, Divider, Form } from "semantic-ui-react";
import { Trans } from "react-i18next";
import { format, eachDayOfInterval } from "date-fns";

import ByDay from "./ByDay";
import Spinner from "../spinner/Spinner";
import DateField from "../form/DateField";
import { FORMAT_DATE } from "../../common/dateFormats";

import "./List.scss";

function List({
  trainingUnits,
  onSelectTrainingUnit,
  displayPeriod,
  appliedFilter,
  filterOptions,
  updateLocationFilter,
  updateCourseCategoryFilter,
  updatePeriodFilter,
  filterTrainingUnitsByDate,
  isLoading,
  loadMore,
  onRefreshData,
  isAdminView
}) {
  return (
    <>
      {/* <Divider clearing hidden /> */}
      <Segment className="fitKiel-members--filterBar">
        <Grid columns="16">
          <Grid.Column computer={3} tablet={4} mobile={8}>
            <Form.Dropdown
              className="fitKiel-courses-coursePlan-FilterDropdown"
              label={
                <Trans i18nKey="coursePlan.index.filter.labels.courseCategory" />
              }
              selection
              fluid
              clearable
              options={filterOptions.courseCategories}
              value={appliedFilter.courseCategoryId}
              onChange={(_, { value }) => updateCourseCategoryFilter(value)}
            />
          </Grid.Column>
          <Grid.Column computer={3} tablet={4} mobile={8}>
            <Form.Dropdown
              className="fitKiel-courses-coursePlan-FilterDropdown"
              label={
                <Trans i18nKey="coursePlan.index.filter.labels.location" />
              }
              selection
              fluid
              clearable
              options={filterOptions.locations}
              value={appliedFilter.locationId}
              onChange={(_, { value }) => updateLocationFilter(value)}
            />
          </Grid.Column>
          <Grid.Column
            computer={4}
            tablet={4}
            mobile={16}
            floated="right"
            className="fitKiel-courses-coursePlan-DateInput-Container"
          >
            <DateField
              label={<Trans i18nKey="coursePlan.index.filter.labels.from" />}
              name="from"
              placeholderTransKey="courses.placeholders.startDate"
              value={format(appliedFilter.from, FORMAT_DATE)}
              setFieldValue={(_, value) => updatePeriodFilter(value)}
              minDate={isAdminView ? null : new Date()}
              maxDate={null}
            />
          </Grid.Column>
        </Grid>
      </Segment>

      <Divider clearing hidden />

      {eachDayOfInterval({
        start: displayPeriod.from,
        end: displayPeriod.to
      }).map(day => {
        const trainingUnitsToday = filterTrainingUnitsByDate(
          trainingUnits,
          day
        );

        if (trainingUnitsToday.length === 0) {
          return null;
        }

        return (
          <ByDay
            date={day}
            trainingUnits={trainingUnitsToday}
            onSelectTrainingUnit={onSelectTrainingUnit}
            onRefreshData={onRefreshData}
            key={day}
          />
        );
      })}

      <Segment basic textAlign="center">
        {isLoading ? (
          <Spinner />
        ) : (
          <Button type="button" labelPosition="left" icon onClick={loadMore}>
            <Icon name="chevron down" />
            <Trans i18nKey="coursePlan.index.actions.loadMore" />
          </Button>
        )}
      </Segment>
    </>
  );
}

List.displayName = "coursePlan/List";

export default React.memo(List);
